import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

import LoginSingle from './Modules/Login/single.js'
import RegisterSingle from './Modules/Register/single.js'
import ContactFormSingle from "./Modules/ContactForm/single.js"
import OrderACallFormSingle from "./Modules/OrderACallForm/single.js"
import PasswordResetFormSingle from "./Modules/PasswordResetForm/single"
import EmailVerificationResendFormSingle from "./Modules/EmailVerificationResendForm/single"
import Language from "../../admin/store/Modules/language.js"
import PacksIndex from "../../client/store/Modules/Packs/index"

export default new Vuex.Store({
    modules: {
        LoginSingle,
        RegisterSingle,
        ContactFormSingle,
        OrderACallFormSingle,
        PasswordResetFormSingle,
        EmailVerificationResendFormSingle,
        Language,
        PacksIndex
    },
    strict: debug,
})
